import { Dispatch } from 'redux';

import {
	setPortalELearnings,
	setPortalGroupTraining,
	setPortalMessages,
	setPortalWhatsNews,
} from '../actions/portal';
import { IPortalMessage, IPortalWhatsNew } from '../actions/portal';
import { IPortalELearning, IPortalGroupTraining } from '../actions/portal';
import { isMobile } from '../utils/MobileCheck';
import ReplaceStyleKeywords from '../utils/ReplaceStyleKeywords';
import AbstractScenario from './AbstractScenario';

/**
 * お知らせシナリオファクトリ
 */
export default class PortalScenarioFactory {
	/**
	 * メッセージ取得シナリオ作成
	 */
	public static createFetchMessages = (dispatch: Dispatch, token: string) => {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<{}> {
			protected process() {
				return this.read('per_notice_MessageBlockModel').then(data => {
					const src: IPortalMessage[] = data.msgList;
					const dest = src.map(message => {
						return {
							messageID: message.messageID,
							messageList: message.messageList.map(m =>
								ReplaceStyleKeywords.replaceStyleKeywords(m)
							),
							startDateStr: message.startDateStr,
							title: ReplaceStyleKeywords.replaceStyleKeywords(
								message.title
							),
						};
					});
					this.dispatch(setPortalMessages({ messages: dest }));
				});
			}
		}(dispatch, token);
		return scenario;
	};

	/**
	 * What's New取得シナリオ作成
	 */
	public static fetchWhatsNews = (dispatch: Dispatch, token: string) => {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<{}> {
			protected process() {
				const param = {
					isMobile: isMobile(),
				};
				return this.read('per_notice_WhatsNewBlockModel', param).then(
					data => {
						const src: IPortalWhatsNew[] = data.whatsNewList;
						const dest = src.map(whatsNew => {
							return {
								careerID: whatsNew.careerID,
								careerTypeID: whatsNew.careerTypeID,
								classID: whatsNew.classID,
								isBtnApply: whatsNew.isBtnApply,
								isBtnResultApply: whatsNew.isBtnResultApply,
								messageID: whatsNew.messageID,
								messageList: whatsNew.messageList.map(m =>
									ReplaceStyleKeywords.replaceStyleKeywords(m)
								),
								startDateStr: whatsNew.startDateStr,
								title: '',
								titleList: whatsNew.titleList.map(m =>
									ReplaceStyleKeywords.replaceStyleKeywords(m)
								),
							};
						});
						this.dispatch(setPortalWhatsNews({ whatsNews: dest }));
					}
				);
			}
		}(dispatch, token);
		return scenario;
	};

	/**
	 * eラーニング情報取得シナリオ作成
	 */
	public static fetchELearnings = (dispatch: Dispatch, token: string) => {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<{}> {
			protected process() {
				return this.read('per_notice_ELearningBlockModel').then(
					data => {
						const eLearnings: IPortalELearning[] = data.elearningList.map(
							(src: any) => ({
								aplType: +src.aplType,
								careerID: src.careerID,
								classID: src.classID,
								contentFlg: +src.contentFlg,
								enqueteFlg: +src.enqueteFlg,
								openEndDate: PortalScenarioFactory.toDate(
									src.openEndDate
								),
								openStartDate: PortalScenarioFactory.toDate(
									src.openStartDate
								),
								progress: src.progress,
								reportFlg: +src.reportFlg,
								showOpenEndDate: src.showOpenEndDate,
								showOpenStartDate: src.showOpenStartDate,
								showStatus: src.showStatus,
								title: src.title,
								uncompletedCareers: src.uncompletedCareers,
								unrepresentedCareerCnt:
									src.unrepresentedCareerCnt,
							})
						);
						this.dispatch(setPortalELearnings({ eLearnings }));
					}
				);
			}
		}(dispatch, token);
		return scenario;
	};

	/**
	 * 集合研修情報取得シナリオ作成
	 */
	public static fetchGroupTraining = (dispatch: Dispatch, token: string) => {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<{}> {
			protected process() {
				return this.read('per_notice_GroupTrainingBlockModel').then(
					data => {
						const groupTraining: IPortalGroupTraining[] = data.groupTrainingList.map(
							(src: any) => ({
								careerID: src.careerID,
								className: src.className,
								classRoom: src.classRoom,
								fromToDate: src.fromToDate,
								title: src.title,
							})
						);
						this.dispatch(
							setPortalGroupTraining({ groupTraining })
						);
					}
				);
			}
		}(dispatch, token);
		return scenario;
	};

	protected static toDate(src: any) {
		if (src === null) {
			return '';
		} else {
			return new Date(
				src.year,
				src.monthValue - 1,
				src.dayOfMonth,
				src.hour,
				src.minute,
				src.second
			);
		}
	}
}



// WEBPACK FOOTER //
// ./src/scenario/PortalScenarioFactory.ts